import React from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
const BecomePartnerStickyBtn = () => {
    $(function(){
        //Scroll event
        $(window).on('scroll', function(){
          var scrolled = $(window).scrollTop();
          if (scrolled > 100) $('.sticky-head-cls-partner').fadeIn('slow');
          if (scrolled < 100) $('.sticky-head-cls-partner').fadeOut('slow');
        });  
      });
  return (
    <>
        <div className="sticky-head-cls-partner">
          <div className="sticky-icon-partner">
            <Link to="/become-a-partner" className='become-a-partner-sticky' >
                <img src='assets/becomepartner_button.webp' />
            </Link>
          </div>
        </div>
    </>
  )
}

export default BecomePartnerStickyBtn